var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 3.75,
    width: 16.5,
    height: 16.5,
    rx: 3.25,
    fill: "url(#paint0_linear_67_3491)",
    stroke: "url(#paint1_linear_67_3491)",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3346 14.2904L16.4077 8.2077C16.5456 8.06923 16.7211 8 16.9342 8C17.1473 8 17.3231 8.069 17.4615 8.207C17.6 8.345 17.6692 8.52064 17.6692 8.73392C17.6692 8.94719 17.6 9.12305 17.4615 9.2615L10.9673 15.7461C10.7865 15.9269 10.5756 16.0173 10.3346 16.0173C10.0936 16.0173 9.88269 15.9269 9.70193 15.7461L7.2077 13.2615C7.06923 13.1236 7 12.9481 7 12.735C7 12.5219 7.069 12.3461 7.207 12.2077C7.345 12.0692 7.52064 12 7.73392 12C7.94719 12 8.12305 12.0692 8.2615 12.2077L10.3346 14.2904Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_67_3491",
    x1: 3,
    y1: 3,
    x2: 24.6158,
    y2: 4.52543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0216468,
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_67_3491",
    x1: 3,
    y1: 3,
    x2: 24.6158,
    y2: 4.52543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0216468,
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCheckbox);
export default __webpack_public_path__ + "static/media/checked-checkbox.c588679b5723657a30f10d735a1ae8fa.svg";
export { ForwardRef as ReactComponent };